"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SpeakerReadiness = require("./SpeakerReadiness");
Object.keys(_SpeakerReadiness).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SpeakerReadiness[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SpeakerReadiness[key];
    }
  });
});